import { render, staticRenderFns } from "./CodPagination.vue?vue&type=template&id=0937ce3a&scoped=true"
import script from "./CodPagination.vue?vue&type=script&lang=js"
export * from "./CodPagination.vue?vue&type=script&lang=js"
import style0 from "./CodPagination.vue?vue&type=style&index=0&id=0937ce3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937ce3a",
  null
  
)

export default component.exports